import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PAGE_OPTION } from 'src/app/constant/constant';
import { PaginatorService } from 'src/app/data/service/paginator.service';

export const INITIAL_DATA: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => LimsTableComponent),
    multi: true
};

@Component({
    selector: 'lims-table',
    templateUrl: './lims-table.component.html',
    styleUrls: ['./lims-table.component.scss'],
    providers: [INITIAL_DATA]
})
export class LimsTableComponent implements OnInit, ControlValueAccessor {

    @ViewChild(MatSort) private sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    @Input()
    public data: any;

    @Input()
    public columns: any[];

    @Output() selected: EventEmitter<any> = new EventEmitter();
    @Output() edit: EventEmitter<any> = new EventEmitter();
    @Output() delete: EventEmitter<any> = new EventEmitter();
    @Output() restore: EventEmitter<any> = new EventEmitter();

    public onModelChange: Function = () => { };
    public onModelTouched: Function = () => { };

    public displayedColumns: string[];
    public master_checked: boolean = false;
    public master_indeterminate: boolean = false;
    public dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
    public pageOptions: any[] = PAGE_OPTION;

    constructor(private translator: PaginatorService,) {
        this.dataSource = new MatTableDataSource([]);
    }

    ngOnInit(): void {
        if (this.data) {
            this.dataSource.data = this.data;
        }

        if (this.paginator) {
            this.dataSource.paginator = this.paginator;
            this.translator.translatePaginator(this.paginator);
        }

        if (this.sort) {
            this.dataSource.sort = this.sort;
            const sortState: Sort = {
                active: 'releaseDate',
                direction: 'desc'
            };
            this.sort.active = sortState.active;
            this.sort.direction = sortState.direction;
            this.sort.sortChange.emit(sortState);
        }

        if (this.columns) {
            this.displayedColumns = this.columns.filter(p => p.checked).map(p => p.key);
            // Kiểm tra nếu tất cả các cột đều được chọn
            const checkedCount = this.columns.filter(p => p.checked).length;
            if (checkedCount === this.columns.length) {
                this.master_checked = true;
                this.master_indeterminate = false;
            }
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        // only run when property "data" changed
        if (changes['data']) {
            this.ngOnInit();
        }

        if (changes['column']) {
            this.displayedColumns = this.columns.filter(p => p.checked).map(p => p.key);
            // Kiểm tra nếu tất cả các cột đều được chọn
            const checkedCount = this.columns.filter(p => p.checked).length;
            if (checkedCount === this.columns.length) {
                this.master_checked = true;
                this.master_indeterminate = false;
            }
        }
    }

    master_change() {
        for (let value of Object.values(this.columns)) {
            value.checked = this.master_checked;
        }
        this.displayedColumns = this.columns.filter(p => p.checked).map(p => p.key);
    }

    public sortData(sort: Sort) {
        const data = Object.assign(this.dataSource.data, []);
        if (!sort.active || sort.direction === '') {
            this.dataSource.data = data;
            return;
        }

        this.dataSource.data = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'name': return this.compare(a.name, b.name, isAsc);
                default: return 0;
            }
        });
    }

    list_change() {
        let checked_count = 0;
        //Get total checked items
        for (let value of Object.values(this.columns)) {
            if (value.checked)
                checked_count++;
        }

        if (checked_count > 0 && checked_count < this.columns.length) {
            // If some checkboxes are checked but not all; then set Indeterminate state of the master to true.
            this.master_indeterminate = true;
        } else if (checked_count == this.columns.length) {
            //If checked count is equal to total items; then check the master checkbox and also set Indeterminate state to false.
            this.master_indeterminate = false;
            this.master_checked = true;
        } else {
            //If none of the checkboxes in the list is checked then uncheck master also set Indeterminate to false.
            this.master_indeterminate = false;
            this.master_checked = false;
        }
        this.displayedColumns = this.columns.filter(p => p.checked).map(p => p.key);
    }

    private compare(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    public selectedItem(element: any) {
        if (this.selected) this.selected.emit(element);
    }

    writeValue(obj: any): void {
        this.onModelChange(obj);
    }
    registerOnChange(fn: Function): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: Function): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        // throw new Error('Method not implemented.');
    }

}
